import {Flex, Span} from 'exsportia-components'

export const DotDivider = () => (
  <Flex
    mx={'8px'}
    height={'100%'}
    justifyContent={'center'}
    alignItems={'center'}
  >
    <Span fontWeight={'bold'}>
      •
    </Span>
  </Flex>
)